import PageName from "../../components/react_helmet/PageName";
import SettingsTable from "../../components/table/SettingsTable";

const Settings = () => {

  return (
    <div className="settings-container">
      <PageName title={"User Management Settings"} />
      <div className="settings-card mb-4 mt-3">
        <SettingsTable />
      </div>
    </div>
  );
};



export default Settings;
